import * as $ from 'jquery';


export default class Blog {

    constructor () {
        $('.articles a').attr('target', '_blank');
    }
}